// @flow
import type { Element, Node } from 'react';
import React from 'react';
import { usePropsValidation } from './validation/runtime-checks/index.js';
import { types as t } from './validation/runtime-checks/index.js';
import { ColumnInternal, RowContext, RowInternal } from './grid.js';

type ColumnElement = Element<typeof Column>;

const TwoColumn = (props: {| children: [ColumnElement, ColumnElement] |}) => {
  const { availableColumns } = React.useContext(RowContext);
  // TODO: Make sure there is a minimum amount of space to render this.
  // availableColumns >= 8

  // a 2 column gap exists in the middle of the columns. In cases where
  // available space is odd, use a 1 column gap instead
  const gapWidth = availableColumns % 2 === 0 ? 2 : 1;
  const remainingSpace = availableColumns - gapWidth;
  const columnWidth = Math.floor(remainingSpace / 2);
  const { failedValidation } = usePropsValidation(props, TwoColumn);
  if (failedValidation) return null;
  const { children } = props;
  return (
    <RowInternal style={{ breakInside: 'avoid' }}>
      <ColumnInternal colSpan={columnWidth}>{children[0]}</ColumnInternal>
      <ColumnInternal colSpan={gapWidth} />
      <ColumnInternal colSpan={columnWidth}>{children[1]}</ColumnInternal>
    </RowInternal>
  );
};
TwoColumn.spec = {
  children: t.tuple([t.elementType(Column), t.elementType(Column)]),
};

function Column(props: {| children: Node |}) {
  const { failedValidation } = usePropsValidation(props, Column);
  if (failedValidation) return null;
  const { children } = props;
  return <div>{children}</div>;
}
Column.spec = {
  children: t.node,
};

export { TwoColumn, Column };
